import React, { useEffect, useRef, useState } from 'react';
import { useCountUp } from 'react-countup';

const AnimateNumber = ({ endNumber, toggleBool, formattedNumber }) => {
  const targetRef = useRef();
  const [state, setState] = useState({});
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion)').matches;

  const { countUp, update } = useCountUp({
    start: endNumber,
    end: endNumber,
    delay: 0,
    duration: 1,
    separator: '.',
  });

  useEffect(() => {
    setState({
      initialLoadDone: false,
    });
  }, [endNumber]);

  useEffect(() => {
    setState({
      width: targetRef.current.offsetWidth !== 0 ? targetRef.current.offsetWidth : 'auto',
      initialLoadDone: true,
    });

    if (!prefersReducedMotion) {
      update(0);
    }
  }, [state.initialLoadDone]);

  if (toggleBool && !prefersReducedMotion) {
    update(endNumber);
  }

  return (
    <strong ref={targetRef} style={{ width: state.width }}>
      {state.initialLoadDone
        ? countUp
        : formattedNumber}
    </strong>
  );
};

export default AnimateNumber;
